export default "__VITE_ASSET__CU1p1HL1__"